import { useState } from 'react';
import {
  Button,
  CloseButton,
  Dialog,
  Portal,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';
import api from '@services/api';

import type { OptionType } from '../types';

type Props = {
  option: OptionType;
  handleClose: () => void;
  afterSubmit: () => void;
};

const ChangeStatusDialog = ({ option, handleClose, afterSubmit }: Props) => {
  const [loading, setLoading] = useState(false);

  const isEnabled = option.is_enabled;

  const onChangeStatusClick = async () => {setLoading(true);
    try {
      const response = await api.put(`/disposition_option/${option.id}`, {
        name: option.name,
        is_enabled: !option.is_enabled,
      });

      if (response?.status === 200) {
        toast.success(`Opção de tabulação ${isEnabled ? 'desabilitada' : 'habilitada'} com sucesso!`);
        afterSubmit();
        handleClose();
      }
    } catch {
      toast.error(`Erro ao ${isEnabled ? 'desabilitar' : 'habilitar'} opção de tabulação. Verifique os dados e tente novamente.`);
    } finally {
      setLoading(false);
    };
  };

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      onOpenChange={handleClose}
      closeOnInteractOutside={false}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg">
            <Dialog.Header>
              <Dialog.Title>
                Tem certeza que deseja
                {' '}
                {isEnabled ? 'desabilitar' : 'habilitar'}
                {' '}
                a opção de tabulação
                {' '}
                {option.name}
                ?
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline" disabled={loading}>Cancelar</Button>
              </Dialog.ActionTrigger>
              <Button
                bg={isEnabled ? "red.500" : "green.700"}
                color="white"
                onClick={onChangeStatusClick}
                loading={loading}
              >
                {isEnabled ? 'Desabilitar' : 'Habilitar'}
              </Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ChangeStatusDialog;
